<template>
	<div v-editable="blok">
		<h1 v-if="pageType === 'home'" class="sr-only">
			{{ blok?.Title || blok.SEO?.title }}
		</h1>
		<div
			class="main-wrapper"
			:class="`${blok?.offset || ''} ${pageType === 'home' ? 'pt-5 pb-10' : ''}`"
		>
			<BlokPriorityScope
				v-for="(body, index) in blok.body"
				:key="body._uid"
				:priority="index <= priorityIndex"
			>
				<StoryblokComponent :blok="body" />
			</BlokPriorityScope>
		</div>
	</div>
</template>

<script setup lang="ts">
import { lastPriorityIndex } from "~/layers/base/utils/imagePriority";
import type { BlokPage } from "~/types/storyblok/storyblok";
import { storeToRefs } from "pinia";

interface Props {
	blok: BlokPage;
}
const { blok } = defineProps<Props>();

const priorityIndex = computed(() => lastPriorityIndex(blok.body));
const pageMeta = usePageMeta();
const pageStore = usePageStore();

const { pageType } = storeToRefs(pageStore);

useSeoMeta({
	title: blok.SEO?.title,
	ogTitle: blok.SEO?.title,
	description: blok.SEO?.description,
	ogDescription: blok.SEO?.og_description,
	ogImage: blok.SEO?.og_image,
	twitterCard: blok.SEO?.twitter_image
});

pageMeta.value = {
	title: blok.Title || blok.SEO?.title,
	description: blok.SEO?.description
};
</script>
